/**
 * L'accueil de l'app côté parent : la journée de toute la famille.
 *
 * Tâches l'a été de la 3.0.0 à la 3.0.1, après la suppression du tableau de
 * bord. Un parent abonné a réclamé sa vue d'ensemble une semaine plus tard, et
 * Amplitude a confirmé qu'une partie des parents ne regardait QUE cette page
 * (10 à 14 % des visiteurs hebdomadaires du tableau de bord n'ouvraient jamais
 * Tâches). La vue famille est donc revenue, sur son propre onglet, et Tâches
 * redevient la page d'UN enfant.
 *
 * Toute redirection « vers l'accueil » passe par cette constante : l'ancienne
 * valeur était écrite en dur dans une vingtaine de fichiers.
 */
export const HOME_PATH = '/tabs/home'
